import classNames from 'classnames';
import { useState } from 'react';
import InputMask from 'react-input-mask';

import styles from './FormInput.module.scss';
import { FormInputProps } from './types';

export const FormInput = ({
  id,
  name,
  placeholder,
  value,
  mods,
  readOnly,
  required,
  disabled,
  type = 'text',
  label,
  isError,
  onChange,
  onFocus = () => undefined,
  onBlur = () => undefined,
  className,
  mask,
}: FormInputProps) => {
  const [isFocus, setIsFocus] = useState(false);

  return (
    <div
      className={classNames(
        styles.inputContainer,
        className,
        mods?.map((mod) => styles[mod]),
        {
          [styles.required]: required,
        },
      )}
    >
      {label && (
        <label
          className={classNames(
            styles.label,
            mods?.map((mod) => styles[mod]),
          )}
          htmlFor={name}
        >
          {label}
          {required && <i className={styles.star}>*</i>}
        </label>
      )}
      {mask ? (
        <InputMask
          id={id}
          name={name}
          placeholder={placeholder}
          type={type}
          readOnly={readOnly}
          required={required}
          disabled={disabled}
          onChange={onChange}
          value={value}
          onFocus={(evt) => {
            setIsFocus(true);
            onFocus(evt);
          }}
          onBlur={(event) => {
            setIsFocus(false);
            onBlur(event);
          }}
          className={classNames(
            styles.input,
            mods?.map((mod) => styles[mod]),
            {
              [styles.isError]: isError,
              [styles.isFocus]: isFocus,
            },
          )}
          mask={mask}
        />
      ) : (
        <input
          id={id}
          name={name}
          placeholder={placeholder}
          type={type}
          readOnly={readOnly}
          required={required}
          disabled={disabled}
          onChange={onChange}
          value={value}
          onFocus={(evt) => {
            setIsFocus(true);
            onFocus(evt);
          }}
          onBlur={(event) => {
            setIsFocus(false);
            onBlur(event);
          }}
          className={classNames(
            styles.input,
            mods?.map((mod) => styles[mod]),
            {
              [styles.isError]: isError,
              [styles.isFocus]: isFocus,
            },
          )}
        />
      )}
      {required && !label && <i className={styles.star}>*</i>}
    </div>
  );
};
